import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { BadgeCheck, X } from 'lucide-react';
interface Buyer {
  name: string;
  city: string;
  offer: string;
}
const NAMES = ['Sofía M.', 'Camila R.', 'Valentina G.', 'Martina L.', 'Lucía F.', 'Julieta P.', 'Florencia S.', 'Agustina T.', 'Micaela B.', 'Carla D.', 'Romina V.', 'Daniela C.', 'Rocío A.', 'Belén N.', 'Antonella H.', 'Brenda Q.', 'Paula E.', 'Yésica O.', 'Gabriela I.', 'Noelia Z.'];
const CITIES = ['CABA', 'Córdoba', 'Rosario', 'La Plata', 'Mendoza', 'Mar del Plata', 'San Miguel de Tucumán', 'Salta', 'Santa Fe', 'Neuquén', 'Quilmes', 'Lomas de Zamora', 'Bahía Blanca', 'San Juan', 'Resistencia', 'Posadas', 'Paraná', 'Corrientes', 'San Luis', 'Río Cuarto'];
const OFFERS = ['la Oferta Completa', 'la Oferta Esencial'];
function randomBuyer(): Buyer {
  return {
    name: NAMES[Math.floor(Math.random() * NAMES.length)],
    city: CITIES[Math.floor(Math.random() * CITIES.length)],
    offer: OFFERS[Math.floor(Math.random() * OFFERS.length)]
  };
}
export function SocialProofPopup() {
  const [buyer, setBuyer] = useState<Buyer | null>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    let showTimeout: ReturnType<typeof setTimeout>;
    let hideTimeout: ReturnType<typeof setTimeout>;
    const cycle = () => {
      setBuyer(randomBuyer());
      setVisible(true);
      // Stay visible ~5.5s
      hideTimeout = setTimeout(() => {
        setVisible(false);
        // Wait random 40-60s before next one
        const nextDelay = 40000 + Math.random() * 20000;
        showTimeout = setTimeout(cycle, nextDelay);
      }, 5500);
    };
    // First popup after a short initial delay
    showTimeout = setTimeout(cycle, 7000);
    return () => {
      clearTimeout(showTimeout);
      clearTimeout(hideTimeout);
    };
  }, []);
  const initials = buyer ? buyer.name.split(' ').map(p => p[0]).join('').slice(0, 2) : '';
  return <div className="fixed bottom-4 left-4 z-[60] pointer-events-none" data-id="element-306">
      <AnimatePresence data-id="element-307">
        {visible && buyer && <motion.div initial={{
        opacity: 0,
        x: -40,
        y: 10
      }} animate={{
        opacity: 1,
        x: 0,
        y: 0
      }} exit={{
        opacity: 0,
        x: -40
      }} transition={{
        type: 'spring',
        stiffness: 260,
        damping: 22
      }} className="pointer-events-auto relative flex items-center gap-3 bg-white rounded-2xl shadow-[0_8px_30px_rgba(0,0,0,0.18)] border border-gray-100 p-2.5 pr-8 max-w-[280px] sm:max-w-[320px]" data-id="element-308">
            <button onClick={() => setVisible(false)} aria-label="Cerrar" className="absolute top-1.5 right-1.5 text-gray-300 hover:text-gray-500 transition-colors" data-id="element-309">
              <X size={14} data-id="element-310" />
            </button>

            {/* Avatar */}
            <div className="flex-shrink-0 relative" data-id="element-311">
              <div className="w-10 h-10 sm:w-11 sm:h-11 rounded-full bg-gradient-to-br from-rosa to-rosa-oscuro text-white flex items-center justify-center font-bold text-[13px]" data-id="element-312">
                {initials}
              </div>
              <span className="absolute -bottom-0.5 -right-0.5 bg-white rounded-full" data-id="element-313">
                <BadgeCheck size={16} className="text-verde fill-verde/15" data-id="element-314" />
              </span>
            </div>

            <div className="min-w-0" data-id="element-315">
              <p className="text-[12px] sm:text-[13px] text-oscuro leading-tight" data-id="element-316">
                <strong className="font-bold" data-id="element-317">{buyer.name}</strong>
                <span className="text-gris" data-id="element-318"> de {buyer.city}</span>
              </p>
              <p className="text-[11px] sm:text-[12px] text-gris leading-tight" data-id="element-319">
                compró{' '}
                <strong className="text-rosa font-semibold" data-id="element-320">
                  {buyer.offer}
                </strong>{' '}
                ahora
              </p>
              <div className="flex items-center gap-1 mt-0.5" data-id="element-321">
                <BadgeCheck size={11} className="text-verde flex-shrink-0" data-id="element-322" />
                <span className="text-[9px] sm:text-[10px] text-verde font-semibold uppercase tracking-wider" data-id="element-323">
                  Compra verificada · hace instantes
                </span>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}